<template>
    <v-daterange v-if="initialRange"
                 :presets="dateRangeOptions ? dateRangeOptions.presets : undefined"
                 start-label="Any"
                 end-label="Now"
                 separator-label="-"
                 highlight-color="blue lighten-3"
                 display-format="MM/DD/YY"
                 :input-props="{
                        appendIcon: 'insert_invitation'
                    }"
                 :value="initialRange"
                 @input="onDateRangeChange"/>

</template>

<script>
    import { VDaterange } from "vuetify-daterange-picker";
    import "vuetify-daterange-picker/dist/vuetify-daterange-picker.css"

    export default {
        name: "DatesPicker",
        components: {VDaterange},
        data: function() {
            this.$store.dispatch('getSettings')
                .then((s) => {
                    this.dateRangeOptions.presets = s.datePickerPresets;
                    this.initialRange = this.setDefaultDateRange();
                    return Promise.resolve(s);
                });

            return {
                initialRange: undefined,
                dateMenu: undefined,
                dateRangeOptions: {
                    presets: undefined,
                },
                selectedDateRange: {
                    startDate: undefined,
                    endDate: undefined,
                },
            }
        },
        methods: {
            onDateRangeChange(selectedRange) {
                this.selectedDateRange = {
                    startDate: selectedRange.start,
                    endDate: selectedRange.end
                };
                this.initialRange = {
                    start: this.selectedDateRange.startDate,
                    end: this.selectedDateRange.endDate
                };
                this.$emit('input', this.selectedDateRange);
            },
            setDefaultDateRange() {
                let initialPreset = this.dateRangeOptions.presets.find(p => p.label === 'Past year');
                let result = {
                    start: initialPreset.range[0],
                    end: initialPreset.range[1]
                };
                this.selectedDateRange = { startDate: result.start, endDate: result.end };
                return result;
            },
        }
    }
</script>

<style scoped>

</style>
